import { render, staticRenderFns } from "./ClaimDocumentTabs.vue?vue&type=template&id=5871d5f3&"
import script from "./ClaimDocumentTabs.vue?vue&type=script&lang=js&"
export * from "./ClaimDocumentTabs.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDocumentTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports